import React, { useState } from 'react'
import {
  Chip,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import { PackType, IEditionMetadata } from '../../types/pack'
import {
  createEditionAndPackData,
  createPanelPackContent,
} from '../../services/pack'
import { StyledDetailsPanel } from './styled'
import { H3, P } from '../StyledText'
import { CreatedItem, EditedItem } from '../DetailsItem'
import { TooltipedChip } from '../TooltipedChip'
import { DetailsPanelContent } from './DetailsPanelContent'
import { EditionLevelSourceFile } from './EditionLevelSourceFile'

interface ILevelDetailsPanel {
  pack: PackType
  edition?: IEditionMetadata
  isDataSteamGraphics?: boolean
}

export const DetailsPanel = ({
  pack,
  edition,
  isDataSteamGraphics,
}: ILevelDetailsPanel) => {
  const [expanded, setExpanded] = useState(true)
  const { title, caption, slugline } = createEditionAndPackData(pack, edition)
  const levelTypeObject = edition || pack
  const editionAndPackContent = [
    { titleName: 'Caption', description: caption },
    { titleName: 'Slugline', description: slugline },
    { titleName: 'Byline', description: pack.byline },
  ]
  const packContent = createPanelPackContent(pack)
  return (
    <StyledDetailsPanel>
      {edition && (
        <EditionLevelSourceFile
          edition={edition}
          isDataSteamGraphics={isDataSteamGraphics}
        />
      )}
      <ExpansionPanel id="details-view" expanded={expanded}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMore color="primary" />}
          onClick={() => {
            setExpanded(!expanded)
          }}
        >
          <H3 mb={2}>Title</H3>
          <P>{title}</P>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          {editionAndPackContent.map(({ titleName, description }, i) =>
            edition && titleName === 'Byline' ? null : (
              <DetailsPanelContent titleName={titleName} key={i}>
                <P>{description}</P>
              </DetailsPanelContent>
            )
          )}
          {levelTypeObject.modified && levelTypeObject.modifiedBy && (
            <EditedItem
              modified={levelTypeObject.modified}
              modifiedBy={levelTypeObject.modifiedBy}
            />
          )}
          <CreatedItem
            created={levelTypeObject.created}
            createdBy={levelTypeObject.createdBy}
          />
          {!edition &&
            packContent.map(({ titleName, description }) => (
              <DetailsPanelContent key={titleName} titleName={titleName}>
                {Array.isArray(description) ? (
                  description.map(({ label, key, shortName = '' }) => (
                    <TooltipedChip
                      disableHover={titleName !== 'Topics'}
                      value={key}
                      label={label}
                      tooltipTitle={shortName}
                      key={label}
                    />
                  ))
                ) : (
                  <Chip label={description} />
                )}
              </DetailsPanelContent>
            ))}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </StyledDetailsPanel>
  )
}
